const config = {
    API_BASE_URL: '/api',
  };

 /*const config = {
    API_BASE_URL: 'http://localhost:8080',
 };*/

 /*const config = {
  API_BASE_URL: 'http://192.168.0.141:8080',
};*/

 /*const config = {
  API_BASE_URL: 'http://192.168.0.200:8080',
};*/

/*const config = {
    API_BASE_URL: 'http://200.141.22.103:8080',
  };*/

  
  export default config;